import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveFileCommand extends BaseCommand {
  CommandName = "RemoveFile";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
